import { render, staticRenderFns } from "./Business-Glossary-Drawer-Linked.vue?vue&type=template&id=3e9b83b8&lang=pug"
import script from "./Business-Glossary-Drawer-Linked.vue?vue&type=script&lang=ts"
export * from "./Business-Glossary-Drawer-Linked.vue?vue&type=script&lang=ts"
import style0 from "./Business-Glossary-Drawer-Linked.vue?vue&type=style&index=0&id=3e9b83b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports